import { defineMessages } from '@edx/frontend-platform/i18n';

const messages = defineMessages({
  redirecting: {
    id: 'portal.components.ssoLoginWrapper.redirecting.message',
    defaultMessage: 'Redirecting...',
    description: 'Message displayed while redirecting',
  },
});

export default messages;
